import styled from "styled-components";
export const ErrorLabel = styled.span `
  display: block;
  margin-top: 0.5rem;
  color: ${({ theme }) => theme.colors.error};
  font-size: ${({ theme }) => theme.fontTokens.font14[0]};
  line-height: ${({ theme }) => theme.fontTokens.font14[0]};
`;
